import {PublicOffSeasonAuditionRequestPersonalForm} from "./PublicOffSeasonAuditionRequestPersonalForm";
import {loading, stopLoading} from "../../helpers/loading";

function initOffSeasonPublicAuditionRequestIndex() {

	const personalDataForm = new PublicOffSeasonAuditionRequestPersonalForm({
		formElement: document.querySelector('.off-season-audition-request-personal-information-form')
	})

	// Setup submit button
	const submitButton = document.querySelector('.submit-button')
	submitButton.addEventListener('click', handleContinueRequest)

	/** Methods */

	function handleContinueRequest() {
		loading();

		personalDataForm.submit()
			.then(response => {
				setTimeout(() => {
					// Show loading again
					loading();

					// Redirect to next step
					// noinspection JSUnresolvedReference
					window.location.href = response.data.redirectUrl;
				})
			})
			.finally(stopLoading)
	}

}

export {
	initOffSeasonPublicAuditionRequestIndex
}
